<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger -is-open">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Section title@@club.heading.productAccess'>Product Access</span>
    </h4>
  </div>
  <div class="esf-accordion__target -is-open">

    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">

        <table class="esf-table" *ngIf="containsData()">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span i18n='Table cell heading@@general.tableCellLabel.product' class="esf-table__cell-inner">Product</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span i18n='Table cell heading@@general.tableCellLabel.status' class="esf-table__cell-inner">Status</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row esf-table__row--is-clickable tixx-connect" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditTixxConnect(true);">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span class="esf-table__cell-inner">Tixx.Connect</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner">{{ findModule(ModulesType.CUSTOMER) }}</span>
              </td>
            </tr>
            <tr class="esf-table__row esf-table__row--is-clickable campaign" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditCampaign(true);">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span class="esf-table__cell-inner">Campaign</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner">{{ findModule(ModulesType.CAMPAIGN) }}</span>
              </td>
            </tr>
            <tr class="esf-table__row esf-table__row--is-clickable tixx-select" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditTixxSelect(true);">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span class="esf-table__cell-inner">Tixx-Select</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner">{{ findModule(ModulesType.LOTTERY) }}</span>
              </td>
            </tr>
            <tr class="esf-table__row esf-table__row--is-clickable fan-score-card" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditFanScoreCard(true);">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span class="esf-table__cell-inner">Fan Score Card</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner">{{ findModule(ModulesType.CUSTOMER_SCORE) }}</span>
              </td>
            </tr>
            <tr class="esf-table__row esf-table__row--is-clickable tixx-webshop" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditTixxWebshop(true);">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span class="esf-table__cell-inner">Tixx Organizer</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner">{{ findModule(ModulesType.TIXX_WEBSHOP) }}</span>
              </td>
            </tr>
            <tr class="esf-table__row esf-table__row--is-clickable campai_membership" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditCampaiMembership(true);">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.product' data-label="Product">
                <span class="esf-table__cell-inner">Campai Membership</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.status' data-label="Status">
                <span class="esf-table__cell-inner">{{ findModule(ModulesType.CAMPAI_MEMBERSHIP) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="esf-table" *ngIf="!containsData()">
          <section class="esf-empty-state flex-empty-state">
            <div>
              <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
                <use xlink:href="#esf-icon-globe"></use>
              </svg>
            </div>
            <p class="esf-paragraph"><small i18n='Text for empty state@@general.emptyStateText.noProductAccess'>There is no product access</small></p>
          </section>
        </table>

      </div>
    </div>
  </div>
</div>
